/*
 * FavoriteCheckbox Messages
 *
 * This contains all the text for the FavoriteCheckbox container.
 */
import { defineMessages } from 'react-intl';

export const scope =
  'app.containers.QuestionnairePage.QuestionLibrary.FavoriteCheckbox';

export default defineMessages({
  removeFromFavorites: {
    id: `${scope}.removeFromFavorites`,
    defaultMessage: 'Remove from favorites',
  },
  addToFavorites: {
    id: `${scope}.addToFavorites`,
    defaultMessage: 'Add to favorites',
  },
});
